"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spacing = {
    spacing01: '2px',
    spacing02: '4px',
    spacing03: '8px',
    spacing04: '12px',
    spacing05: '16px',
    spacing06: '24px',
    spacing07: '32px',
    spacing08: '40px',
    spacing09: '48px',
};
exports.default = spacing;
